import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { cn } from '@/app/utils'
import { AppButton } from '@/components/shared/button'
import { AppLoader } from '@/components/shared/loader'
import { AppModal } from '@/components/shared/modal'

type Props = {
  opened: boolean
  header?: string
  isPending?: boolean
  onClose: () => void
  onConfirm: () => void
}

const ConfirmDeleteModal = ({
  opened,
  header,
  isPending = false,
  onClose,
  onConfirm
}: Props) => {
  const { breakpoint } = useCurrentBreakpoint()
  const isMobileScreen = [
    ScreenSize.Xxs,
    ScreenSize.Xs,
    ScreenSize.Sm
  ].includes(breakpoint)

  return (
    <AppModal
      opened={opened}
      onClose={onClose}
      header={header}
      overlayClassName="!bg-black/50"
      className="mx-16 w-[460px] sm:!h-auto sm:!rounded-16"
      headerWrapperClassName="justify-between !gap-10 !pl-32 !pr-20 !pb-12 sm:!pb-24 sm:!pb-12"
      headerClassName="text-28 sm:text-24"
      closeButtonClassName="ml-10 !h-40 !w-40 shrink-0 sm:p-4"
      contentClassName="!mt-0 gap-y-24 pb-32 sm:px-24 sm:pb-24"
    >
      <div className="flex flex-col gap-12">
        <AppButton
          variant="secondary"
          aria-busy={isPending}
          className={cn(
            'w-full !border-red-80 !bg-red-80 !text-white hover:!bg-red-90',
            isPending && 'pointer-events-none'
          )}
          onClick={onConfirm}
          size={isMobileScreen ? 'small' : 'large'}
        >
          {isPending ? <AppLoader noText variant="primary" /> : 'Удалить'}
        </AppButton>
        <AppButton
          variant="backless"
          className="w-full"
          onClick={onClose}
          size={isMobileScreen ? 'small' : 'large'}
        >
          Отмена
        </AppButton>
      </div>
    </AppModal>
  )
}

export { ConfirmDeleteModal }
